import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Badge,
  Divider,
  Tooltip,
  Popconfirm,
  message,
  Select,
  Icon,
} from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import { getLabelStrData } from '../../utils/convertData';
import { getPathHeader } from '../../../../../utils/utils';
import styles from './index.less';

const { ListTable } = ListPage;
const { Option } = Select;

const statusIcon = {
  1: '#FAAD14',
  3: '#F5222D',
  4: '#1785EC',
  5: '#52C41A',
  7: '#52C41A',
  8: '#C3C3C3',
  10: '#C3C3C3',
  11: '#1785EC',
  12: '#F5222D',
};

const statusText = {
  1: '拟稿中',
  3: '被打回',
  4: '审批中',
  5: '审批成功',
  7: '已发布',
  8: '已撤下',
  10: '已撤回',
  11: '处理中',
  12: '上传失败',
};
@connect()
class Matter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        status: 0,
        newsTypes: '2',
      },
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchPermissions();
    this.fetchNewsLists(params);
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          status: values.status ? encodeURIComponent(values.status) : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchNewsLists(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = { ...params, title: '', page: 1, status: 0 };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsLists(tempParams);
  };

  fetchPermissions = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'articleSubmissions/fetchPermissions',
      params: {
        appCode: getAppCode(),
      },
    }).then(res => {
      this.setColumns(res);
    });
  };

  fetchNewsLists = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchNewsLists',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  confirm = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchDeleteById',
      params: { id: record.id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('删除成功');
        const { params } = this.state;
        this.fetchNewsLists(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchSubmit = record => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchSubmit',
      params: { ids: record.id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('提交成功');
        this.fetchNewsLists(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = type => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        fixed: 'left',
        width: 330,
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'newstype',
        key: 'newstype',
        render: () => {
          return <span>视频素材</span>;
        },
      },
      {
        title: '最后编辑时间',
        dataIndex: 'gmtModify',
        key: 'gmtModify',
        render: (text, record) => {
          return <span>{moment(text || record.createTime).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
      {
        title: (
          <div>
            <span style={{ marginRight: 2 }}>处理状态</span>
            <Tooltip
              placement="top"
              title="根据上传素材的大小，存在几分钟状态更新时间，可刷新页面更新状态"
              autoAdjustOverflow
            >
              <Icon type="question-circle" />
            </Tooltip>
          </div>
        ),
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return <Badge color={statusIcon[text]} text={statusText[text]} />;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          if (type) {
            return (
              <span>
                {(record.status === 1 ||
                  record.status === 3 ||
                  record.status === 8 ||
                  record.status === 10) && (
                  <>
                    <a
                      onClick={e => {
                        e.stopPropagation();
                        router.push(
                          `/${getPathHeader()}/submissions/matter/create?id=${
                            record.id
                          }&appCode=${getAppCode()}`
                        );
                      }}
                    >
                      编辑
                    </a>
                    <Divider type="vertical" />
                    <a
                      onClick={e => {
                        e.stopPropagation();
                        this.fetchSubmit(record);
                      }}
                    >
                      提交
                    </a>
                    <Divider type="vertical" />
                    <Popconfirm
                      title="确定删除？"
                      placement="top"
                      okText="确定"
                      cancelText="取消"
                      onConfirm={e => {
                        e.stopPropagation();
                        this.confirm(record);
                      }}
                      onClick={e => e.stopPropagation()}
                      onCancel={e => e.stopPropagation()}
                    >
                      <a>删除</a>
                    </Popconfirm>
                  </>
                )}
              </span>
            );
          }
          return null;
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsLists(tempParams);
  };

  // 跳转详情
  handleGoToDetail = id => {
    // router.push(
    //   `/${getPathHeader()}/submissions/submissions/approvalDetail?id=${id}&appCode=${getAppCode()}`
    // );
    router.push(`/${getPathHeader()}/matter/manage/detail?id=${id}&appCode=${getAppCode()}&type=matter`);
  };

  createMatter = () => {
    router.push(`/${getPathHeader()}/submissions/matter/create?appCode=${getAppCode()}`);
  };

  render() {
    const { columns, loading, dataSource, params, totalElements } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <section className={styles['search-area']}>
            <Row>
              <Col span={8}>
                <Form.Item {...formItemLayout} label="标题">
                  {getFieldDecorator('title', {
                    rules: [
                      {
                        max: 50,
                        message: '请勿超过50个字!',
                      },
                    ],
                  })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...formItemLayout} label="状态">
                  {getFieldDecorator(`status`, {
                    initialValue: 0,
                  })(
                    <Select placeholder="请选择">
                      <Option value={0}>全部</Option>
                      <Option value={1}>拟稿中</Option>
                      <Option value={3}>被打回</Option>
                      <Option value={4}>审批中</Option>
                      <Option value={5}>审批成功</Option>
                      <Option value={7}>已发布</Option>
                      <Option value={8}>已撤下</Option>
                      <Option value={10}>已撤回</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col offset={20} style={{ textAlign: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={this.search}>
                    查询
                  </Button>
                  <Button onClick={this.reSet}>重置</Button>
                </Form.Item>
              </Col>
            </Row>
          </section>
          <section className="create-button">
            <Button type="primary" onClick={this.createMatter}>
              + 新建视频素材
            </Button>
          </section>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>
      </Container>
    );
  }
}

const MatterFrom = Form.create()(Matter);
export default MatterFrom;
